import { render, staticRenderFns } from "./trendKLine.vue?vue&type=template&id=24058e58&scoped=true&"
import script from "./trendKLine.vue?vue&type=script&lang=js&"
export * from "./trendKLine.vue?vue&type=script&lang=js&"
import style0 from "./trendKLine.vue?vue&type=style&index=0&id=24058e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24058e58",
  null
  
)

export default component.exports